import React, { useMemo } from "react";

import _ from "lodash";

import { useGetCarbonProgramById, useGetPartner, useGetPracticeCrops, useParams } from "utils";

import { Flex, ListCard, MainPage, Typography } from "components";

import { farmLevelFootprintingRows, fieldsManagementRows, platformFeatureRows, programRows } from "pages/admin/carbonPrograms/details/programSettingRows";

const CarbonProgramDetails: React.FC = () => {
  const params = useParams<{ id?: string }>();
  const carbonProgramQuery = useGetCarbonProgramById(params.id);
  const allCrops = useGetPracticeCrops({ enabled: true, isAdmin: true });
  const { data: partner } = useGetPartner(carbonProgramQuery.data?.partnerId ?? "");

  const cropNames = useMemo(() => _.mapValues(_.keyBy(allCrops.data ?? [], "id"), "name"), [allCrops.data]);

  if (carbonProgramQuery.isLoading) return <div>Loading program {params.id}…</div>;
  if (!carbonProgramQuery.data) return <div>Program not found.</div>;

  const carbonProgram = carbonProgramQuery.data;
  const lookups = { cropNames, partnerName: partner?.name };
  const features = platformFeatureRows(carbonProgram);

  return (
    <MainPage pageName="Carbon Program Details">
      <Flex vertical gap={32}>
        <Flex vertical gap={8}>
          <Typography variant="h2">{carbonProgram.programName}</Typography>
          <Typography variant="paragraph-m" color="grey-600">
            Hover a setting's info icon for what it does. Grey values are platform defaults (not configured).
          </Typography>
        </Flex>

        <ListCard title="Program" dataPairs={programRows(carbonProgram, lookups)} />

        <Flex vertical gap={16}>
          <Typography variant="h2">Platform features</Typography>
          <Flex gap={16} align="flex-start">
            <ListCard className="flex-1" title="Fields management" dataPairs={features.fieldManagement} />
            <ListCard className="flex-1" title="Footprinting" dataPairs={features.footprinting} />
            <ListCard className="flex-1" title="Planning" dataPairs={features.planning} />
          </Flex>
        </Flex>

        <ListCard title="Fields management settings" dataPairs={fieldsManagementRows(carbonProgram, lookups)} />
        <ListCard title="Footprinting settings" dataPairs={farmLevelFootprintingRows(carbonProgram, lookups)} />
      </Flex>
    </MainPage>
  );
};

export default CarbonProgramDetails;
